import React, {useEffect} from 'react';
import {createRoot} from 'react-dom/client';

import CalculatorApi from '@/components/CalculatorApi/CalculatorApi';

import {parseCalculatorData} from '@/utils/parseCalculatorData';

export const useCalculatorType = ({articleRef, data}) => {
  useEffect(() => {
    if (articleRef?.current && data) {
      const elements = [...articleRef.current.querySelectorAll('[data-type="calculator"]')];

      elements.forEach(el => {
        const fetchedData = data[el.dataset.id];

        if (fetchedData) {
          createRoot(el).render(<CalculatorApi data={parseCalculatorData(fetchedData)}/>);
        }
      });
    }
  }, [articleRef, data]);
};
